import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { GwiResearchQaResponseDto } from '@inference.engine/api-client/web';

import { askPersonaResearch } from '../api/gwi-research.api';
import { GWI_RESEARCH_QUERY_KEYS, type GwiResearchCategory } from '../api/query-keys';

export const useAskPersonaResearch = (personaId: string, category?: GwiResearchCategory) => {
  const queryClient = useQueryClient();

  return useMutation<GwiResearchQaResponseDto, Error, string>({
    mutationFn: (question: string) => askPersonaResearch(personaId, { question, category }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: GWI_RESEARCH_QUERY_KEYS.history(personaId, category),
      });
    },
  });
};
